/* eslint-disable no-undef */
import React, { useEffect, useState, Fragment, useContext } from 'react';
import { useSelector, connect } from 'react-redux';
import LocaleContext from '../../../constants/localization';
import LiteralEdit from './LiteralEdit';
import { openStatementTextModal } from 'actions/modalActions';

const StatementTextEdit = ({ field, openStatementTextModal  }) => {
  const LS = useContext(LocaleContext);
  const openModal = () => openStatementTextModal({
    label: `${LS.statement.presetStatementTexts}`,
    onSave: addStatementPresetText
  });
  
  const addStatementPresetText = (value) =>{
	if(value){
		value = value.replace(/\r\n\r\n/g, '<p></p>');
		const existingText = field.values[0];
		let newText = value;
		if(existingText && existingText.length > 0){
			newText = existingText+"\n"+value;
		}
		field.setValue(0, newText);
	}
  }
  
  return (
	  <div>
		  <a 
		  style={{padding: '0.5rem', cursor: 'pointer'}}
		  onClick={openModal}
		  target="_blank">
		  {LS.statement.addPresetStamentText}
		  </a>
	      <LiteralEdit
	        style={{ marginLeft: 0, paddingLeft: 0 }}
	        field={field} />
      </div>
  );
};

export default connect(null, { openStatementTextModal })(StatementTextEdit);